var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 12,
    viewBox: "0 0 35 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_1313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.088 4.16825C18.0682 5.72914 19.4791 6.60012 20.5418 7.11802C21.6338 7.64934 22.0005 7.99009 21.9962 8.4653C21.9881 9.19247 21.1252 9.51344 20.3178 9.52591C18.9091 9.54773 18.09 9.14558 17.4389 8.84142L16.9314 11.216C17.5847 11.517 18.7944 11.7795 20.0489 11.7911C22.9935 11.7911 24.9199 10.3375 24.9304 8.08389C24.9419 5.22371 20.9742 5.0654 21.0013 3.78698C21.0107 3.39933 21.3806 2.98566 22.1911 2.88048C22.5923 2.82735 23.6998 2.78669 24.9554 3.3649L25.4483 1.06749C24.773 0.821617 23.9051 0.586183 22.8246 0.586183C20.0531 0.586183 18.1037 2.05951 18.088 4.16825ZM30.1838 0.784072C29.6461 0.784072 29.193 1.09771 28.9908 1.57902L24.7845 11.6223H27.727L28.3125 10.0041H31.9081L32.2478 11.6223H34.8412L32.5781 0.784072H30.1838ZM30.5954 3.71189L31.4446 7.78177H29.119L30.5954 3.71189ZM14.5204 0.784207L12.2011 11.6222H15.005L17.3233 0.783936H14.5204V0.784207ZM10.3725 0.783936L7.45402 8.16101L6.27346 1.88859C6.13494 1.18839 5.5879 0.784072 4.98041 0.784072H0.209644L0.142822 1.0988C1.12224 1.31133 2.23503 1.65411 2.90921 2.02088C3.32179 2.24493 3.43944 2.44079 3.57498 2.97319L5.811 11.6223H8.77405L13.3168 0.784072H10.3725",
    fill: "url(#paint0_linear_85_1313)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_1313",
    x1: 16.0951,
    y1: 12.0158,
    x2: 16.4194,
    y2: 0.508256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_1313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.6984,
    height: 11.2499,
    fill: "white",
    transform: "translate(0.142822 0.586189)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosVisa);
export default __webpack_public_path__ + "static/media/logos_visa.b9b8c9fd0bfc29d23e209e924155c7b5.svg";
export { ForwardRef as ReactComponent };